import { isCareIndustryPageKey } from '../content/careIndustryLabels.js';
import type { LandingContent } from '../content/landingContentTypes.js';
/** Keep customized labels, omissions and indexes; append only the newly introduced care links. */
export const backfillCareIndustryNavigation = (content: LandingContent, defaults: LandingContent): void => {
  const links = (content.industryNav ??= []);
  for (const item of defaults.industryNav ?? []) {
    const key = item.href.match(/^\/branchen\/([^/?#]+)/u)?.[1] ?? '';
    if (isCareIndustryPageKey(key) && !links.some(link => link.href === item.href)) links.push({ ...item });
  }
};
